import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

// Inject Telegram init data for auth
api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initData) {
    config.headers['X-Telegram-Init-Data'] = window.Telegram.WebApp.initData
  }
  return config
})

// Activities
export const getActivities = () => api.get('/activities')
export const getVenueEvents = (venueId) => api.get(`/venues/${encodeURIComponent(venueId)}/events`)

// Subscriptions
export const getSubscriptions = () => api.get('/subscriptions')
export const addSubscription = (data) => api.post('/subscriptions', data)
export const removeSubscription = (venueId) =>
  api.delete(`/subscriptions/${encodeURIComponent(venueId)}`)
export const getSubscriptionStatus = (venueId) =>
  api.get(`/subscriptions/${encodeURIComponent(venueId)}/status`)

// Poll templates
export const getPollTemplates = (venueId) =>
  api.get('/poll-templates', venueId ? { params: { venueId } } : {})
export const createPollTemplate = (data) => api.post('/poll-templates', data)
export const updatePollTemplate = (id, data) => api.put(`/poll-templates/${id}`, data)
export const deletePollTemplate = (id) => api.delete(`/poll-templates/${id}`)
export const sendPollFromTemplate = (id, chatId, eventData) =>
  api.post(`/poll-templates/${id}/send`, { chatId, eventData })
export const executeInlinePollAction = (token) =>
  api.post('/inline-poll-actions/execute', { token })

// User settings
export const getUserSettings = () => api.get('/user-settings')
export const updateUserSettings = (data) => api.put('/user-settings', data)

// Message templates
export const getMessageTemplates = (venueId) =>
  api.get('/message-templates', venueId ? { params: { venueId } } : {})
export const createMessageTemplate = (data) => api.post('/message-templates', data)
export const updateMessageTemplate = (id, data) => api.put(`/message-templates/${id}`, data)
export const deleteMessageTemplate = (id) => api.delete(`/message-templates/${id}`)
export const getTemplateVariables = () => api.get('/message-templates/variables')
export const previewMessageTemplate = (templateBody, sampleData) =>
  api.post('/message-templates/preview', { templateBody, sampleData })

// Admin
export const checkAdminStatus = (chatId) => api.get('/admin/check', { params: { chatId } })
export const checkGlobalAdminStatus = () => api.get('/admin/me')
export const getBackendVersion = () => api.get('/version')
export const getUserChats = () => api.get('/user-chats')
export const updateEventOverride = (timeSlotId, data) =>
  api.patch(`/admin/availability/${encodeURIComponent(timeSlotId)}`, data)

// Manual events
export const getManualEvents = () => api.get('/manual-events')
export const createManualEvent = (data) => api.post('/manual-events', data)
export const updateManualEvent = (id, data) => api.put(`/manual-events/${id}`, data)
export const deleteManualEvent = (id) => api.delete(`/manual-events/${id}`)

export default api
